import { render, staticRenderFns } from "./margin-splits.vue?vue&type=template&id=5bd4ef0a"
import script from "./margin-splits.vue?vue&type=script&lang=js"
export * from "./margin-splits.vue?vue&type=script&lang=js"
import style0 from "./margin-splits.vue?vue&type=style&index=0&id=5bd4ef0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports